import {
  EXTRA_LARGE_VIEWPORT,
  LARGE_VIEWPORT,
} from "../../state/modules/layout";

const getGridViewportCategory = (viewportCategory) =>
  viewportCategory === EXTRA_LARGE_VIEWPORT
    ? LARGE_VIEWPORT
    : viewportCategory || LARGE_VIEWPORT;

export default getGridViewportCategory;
